import type { ModuleManifest } from '../types.js'

/**
 * ХАРИЛЦАГЧИЙН ХҮСЭЛТ — худалдааны төлөөлөгчөөс ирэх өөрчлөлтийн хүсэлт.
 *
 * Эх систем (cloud.maximus.mn) дээрх `coresoft/crm/customer-requests` ба
 * `coresoft/customer/route-change` хоёр дэлгэцийн эквивалент.
 *
 * ! ЭХ СИСТЕМД НЭГ ХҮСНЭГТ, ХОЁР ДЭЛГЭЦ. `customer_requests` нь төрлөөрөө
 * ! хуваагдана: `new_registration`/`info_update` нь CRM талд, `route_update`/
 * ! `location_update` нь маршрутын талд харагдана. Бид тэр бүтцийг хэвээр
 * ! авав — хоёр хүснэгт болговол «нэг харилцагчийн бүх хүсэлт» гэсэн асуултад
 * ! хоёр газраас хайх болно.
 *
 * ! 1С-Д БИШ, МАНАЙ БААЗАД амьдарна. Хүсэлт нь батлагдах хүртэл 1С-д
 * ! байхгүй — тэр нь яг л энэ модулийн оршин байх шалтгаан: батлагдаагүй
 * ! өөрчлөлтийг хаа нэгтээ барих хэрэгтэй. Батлагдсаны дараа операторын гараар
 * ! 1С-д ордог (эх системд ч тэгдэг).
 */
export const partnersModule = {
  key: 'partners',
  name: 'Харилцагчийн хүсэлт',
  description: 'Шинэ харилцагч нээх, мэдээлэл засах, маршрут ба байршил шинэчлэх хүсэлтүүд.',
  version: '1.0.0',
  icon: 'UserPlusIcon',

  permissions: [
    { resource: 'partners.requests', action: 'list', description: 'Харилцагчийн хүсэлт харах' },
    { resource: 'partners.requests', action: 'show', description: 'Хүсэлтийн дэлгэрэнгүй' },
    { resource: 'partners.requests', action: 'create', description: 'Хүсэлт үүсгэх' },

    /*
     * ! ХЯНАХ эрх нь ХАРАХААС тусдаа. Батлах үйлдэл нь 1С руу гараар оруулах
     * ! ажлыг эхлүүлдэг тул «харж чадах бүхэн баталж чадна» гэсэн байдал
     * ! үүсэх ёсгүй.
     */
    { resource: 'partners.requests', action: 'review', description: 'Хүсэлт батлах, цуцлах' },
  ],

  navigation: [
    {
      label: 'Харилцагч',
      items: [
        {
          label: 'Шинэ харилцагч',
          href: '/partners/requests',
          icon: 'UserPlusIcon',
          iconClassName: 'text-emerald-600 dark:text-emerald-400',
          permission: 'partners.requests:list',
        },
        {
          /*
           * ! ТУСДАА ЦЭС, НЭГ ХҮСНЭГТ. Маршрут солих хүсэлтийг өөр хүн
           * ! (түгээлтийн зохицуулагч) хардаг тул эх системийн адил тусад нь
           * ! гаргав — нэг жагсаалт дотор шүүлтүүрээр нуувал өдөр бүр
           * ! шүүлтүүрээ сэргээх болно.
           */
          label: 'Маршрут солих',
          href: '/partners/route-change',
          icon: 'RouteIcon',
          iconClassName: 'text-amber-600 dark:text-amber-400',
          permission: 'partners.requests:list',
        },
      ],
    },
  ],

  resources: [
    {
      name: 'partners.requests',
      label: 'Харилцагчийн хүсэлт',
      list: '/partners/requests',
      show: '/partners/requests/:id',
    },
  ],
} as const satisfies ModuleManifest
